/**
 * ErrorListCategoryTitle  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";

export interface IErrorListCategoryTitleProps {
	children?: React.ReactNode;
	inset?: boolean;
	secondary?: boolean;
}

export const ErrorListCategoryTitle = React.memo<IErrorListCategoryTitleProps>(
	({ children, secondary, inset }) => {
		const baseClass = BEM("edt-error-list", "category-title", { inset, secondary });

		return <div className={baseClass.toClassName()}>{children}</div>;
	}
);

ErrorListCategoryTitle.displayName = "ErrorListCategoryTitle";
